<template>
    <div>
        <div class="page f-c-ss">
            <div class="questionName">
                ({{result.sort == 0 ? "单选题": "多选题"}}) &nbsp;{{ result.question || "-" }}
            </div>
            <Spin :spinning="loading">
                <div class="container">
                    <CheckboxGroup v-model="selectId" :style="{ marginTop: '20px' }">
                        <div :style="{ marginBottom: '12px' }" v-for="(item, index) in result.tags" :key="item.id">
                            <Checkbox :value="item.id">{{ item.content }}</Checkbox>
                        </div>
                    </CheckboxGroup>

                    <div class="btn-group" v-if="result.question">
                        <Button type="primary" @click="saveQuestion">保存</Button>
                        <Button type="primary" @click="toMatch" :style="{ marginLeft: '10px' }">立即匹配</Button>

                        <Button :style="{ marginLeft: '100px' }" @click="prev" v-if="result.last">上一题</Button>

                        <Button :style="{ marginLeft: '10px' }" @click="next" v-if="result.next">下一题</Button>
                    </div>
                </div>
            </Spin>
        </div>
    </div>
</template>

<script>
import { Message } from "ant-design-vue";
import { getAction } from "@/util/require.js";
export default {
    name: "questionItem",
    components: {
     
    },
    data() {
        return {
            id: "",
            selectId: [],
            result: {},
            loading: false
        };
    },
    created() {
        this.id = this.$route.query.itemId;
        this.getData(this.id);
    },
    mounted() {},
    methods: {
        getData(id) {
            this.loading = true;
            getAction("/hq/webPage/recordQuestionOne", {
                id
            }).then(res => {
                if (res.success) {
                    this.result = res.result;
                }
                this.loading = false;
            });
        },
        saveQuestion() {
            this.next();
        },
        recordQuestion() {
            let ids = this.selectId.join(",");
            this.loading = true;
            return getAction("/hq/webPage/recordQuestionForQuestion", {
                questionId: this.id,
                ids
            }).then(res => {
                if (res.success) {
                    Message.success(res.message);
                }
                this.loading = false;
            });
        },
        prev() {
            if (this.result.last) {
                this.recordQuestion().then(res => {
                    this.getData(this.result.last);
                    this.selectId = [];
                });
            }
        },
        next() {
            if (this.result.next) {
                this.recordQuestion().then(res => {
                    this.getData(this.result.next);
                    this.selectId = [];
                });
            }
        },
        toMatch() {
            this.recordQuestion().then(res=>{
                this.$router.push({ path: "/policyMatch" });
            })
        }
    }
};
</script>

<style scoped lang="scss">
.page {
    min-height: 500px;
    width: 1200px;
}

.questionName {
    width: 100%;
    margin-top: 90px;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
}
.container {
    width: 1200px;
    min-height: 300px;
}
.btn-group {
    margin-top: 104px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
